<template>
  <v-container fluid class="pt-3">
    <GPAdminTable :shop="shop" :gp="true" :showStat="true"></GPAdminTable>
  </v-container>
</template>
<script>
import GPAdminTable from "@/components/table/GPAdminTable";

export default {
  components: {
    GPAdminTable,
  },
  data() {
    return {
      shop: null,
    };
  },
  created() {},
};
</script>
